// extracted by mini-css-extract-plugin
module.exports = {"ProductVariantPicker":"productVariantPicker_ProductVariantPicker__ZqoDi"};